/**
 * 悬浮加购：仅当正式加购按钮已经滚出视口上方时显示。
 * 首屏加购还在下方时不出现。
 */
(function () {
  function initRoot(root) {
    if (!(root instanceof HTMLElement) || root.dataset.atcFabReady === '1') return;

    var fab = root.querySelector('[data-atc-fab]');
    var sectionId = root.dataset.section || '';
    var primary = sectionId
      ? root.querySelector('#ProductSubmitButton-' + sectionId)
      : root.querySelector('.product-form__submit--dominant');
    var target =
      root.querySelector('.product-form__buttons--conversion') ||
      root.querySelector('.product-form__buttons') ||
      primary;

    if (!fab || !target || !primary) return;
    root.dataset.atcFabReady = '1';

    function setVisible(next) {
      fab.classList.toggle('is-visible', next);
      fab.setAttribute('aria-hidden', next ? 'false' : 'true');
      fab.tabIndex = next ? 0 : -1;
    }

    function syncDisabled() {
      var disabled =
        primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      fab.disabled = disabled;
      fab.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      fab.classList.toggle('is-disabled', disabled);
    }

    function shouldShowFab() {
      var rect = target.getBoundingClientRect();
      // 只有主加购整块都滚到视口上方，才出悬浮钮；还在下方/可见时不出
      return rect.bottom < 8;
    }

    function update() {
      setVisible(shouldShowFab());
    }

    var io = new IntersectionObserver(update, {
      threshold: [0, 0.01, 0.2, 1],
      rootMargin: '0px',
    });
    io.observe(target);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    fab.addEventListener('click', function () {
      if (fab.disabled) return;
      primary.click();
    });

    var mo = new MutationObserver(syncDisabled);
    mo.observe(primary, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });

    syncDisabled();
    setVisible(false);
    update();
  }

  function boot() {
    document.querySelectorAll('product-info[data-section]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
